<template>
  <transition name="sideUp">
    <div v-show="$store.state.toast.isShow" class="header-toast">
      <div class="header-toast-content">
        <i :class="$store.state.toast.iconClass"><span class="path1"></span><span class="path2"></span></i>
        <span class="header-toast-title">{{$store.state.toast.message}}</span>
      </div>
      <span class="header-toast-close icon-cancel" @click="closeToast"></span>
    </div>
  </transition>
</template>

<script>
  import store from 'store'
  export default {
    data () {
      return {
      }
    },
    methods: {
      closeToast () {
        store.commit('setToast', {isShow: false})
      }
    },
    computed: {
    },
    watch: {
      '$store.state.toast.isShow': {
        handler: function (val, oldVal) {
          if (val === true) {
            if (store.state.toast.autoClose === undefined || store.state.toast.autoClose) {
              setTimeout(function () {
                store.commit('setToast', {isShow: false})
              }, 2000)
            }
          }
        },
        deep: true
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/global.styl"
  .header-toast
    position: fixed;
    z-index: 20;
    background: #ffffff;
    height: 1.17rem;
    line-height: 1.17rem;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid $split_color_fat;
    top: 1.17rem;
    span
      color: $slave_font;
  .header-toast-close
    position: absolute;
    right: 0.4rem;
    top: 0.4rem;
  .header-toast-content
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: keep-all;
    padding: 0 1rem 0 1rem;
  .header-toast-title
    padding-left: 0.2rem;
    font-size: 0.32rem;
</style>



// WEBPACK FOOTER //
// toast.vue?472a3c0c